import { render, staticRenderFns } from "./EditLocation.vue?vue&type=template&id=4dfcd979&scoped=true&"
import script from "./EditLocation.vue?vue&type=script&lang=ts&"
export * from "./EditLocation.vue?vue&type=script&lang=ts&"
import style0 from "./EditLocation.vue?vue&type=style&index=0&id=4dfcd979&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4dfcd979",
  null
  
)

export default component.exports